import AppRouterProvider from './AppRouterProvider';

export default AppRouterProvider;
